// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"d0fc86f6","416":"4bd89e1a","471":"d0fc86f6","479":"4bd89e1a","896":"1cee19ec"}[chunkId] + ".chunk.css";
};